import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect, useRef } from 'react';
import { useUserLocation } from '~/context/common/UserContext';
import {
  useDeliveryInfo,
  useDeliveryPickup,
  usePickupInfo
} from '~/context/vdp/DeliveryPickupContext';

export default function useSendDeliveryPickup(): void {
  const { trackEvent } = useContext(AnalyticsContext);
  const { isLoaded } = useDeliveryPickup();
  const delivery = useDeliveryInfo();
  const pickup = usePickupInfo();
  const { zip } = useUserLocation();

  const zipRef = useRef(zip);
  useEffect(() => {
    zipRef.current = zip;
  }, [zip]);

  useEffect(() => {
    if (!isLoaded) return;
    trackEvent('Delivery and Pickup', {
      delivery,
      pickup,
      zip: zipRef.current
    });
  }, [delivery, isLoaded, pickup, trackEvent]);
}
